import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GenericOption, GenericOptionGroup, SubCategory, WorkTypeService} from '@cas-hub/acabim-common-client';
import {FormControl, FormGroup} from '@angular/forms';
import {CategoryTableData, SubCategoryTableData} from '../../work-order.model';

@Component({
  selector: 'acabim-admin-work-order-subcategory-details',
  templateUrl: './work-order-subcategory-details.component.html',
  styleUrls: ['./work-order-subcategory-details.component.scss']
})
export class WorkOrderSubcategoryDetailsComponent implements OnInit {

  @Input() cbiClassOptions: GenericOption[] = [];
  @Input() cbiClassOptionsGrouped: GenericOptionGroup[] = [];
  @Input() set workSubCategoryData(value: SubCategoryTableData) {
    console.dir(value);
    if (value && this.editForm) {
      this.workSubCategoryDetails = value;
      this.editForm.get('name')?.setValue(this.workSubCategoryDetails.name);
      this.editForm.get('cbiClass')?.setValue(this.workSubCategoryDetails.cbi_class?.id);
      if (this.workSubCategoryDetails.status && this.workSubCategoryDetails.status > 0) {
        this.editForm.get('status')?.setValue(1);
      } else {
        this.editForm.get('status')?.setValue(0);
      }
      this.viewStatus = 'edit';
    } else {
      this.init();
    }
  }
  @Input() set workCategoryData(value: CategoryTableData) {
    console.dir(value);
    if (value) {
      this.workCategoryDetails = value;
    }
  }
  @Output() cancelled = new EventEmitter<any>();
  @Output() completed = new EventEmitter<any>();

  isLoading = false;
  parcel: SubCategory | null = null;
  showDone = false;
  viewStatus = 'add';
  workCategoryDetails: CategoryTableData | null = null;
  workSubCategoryDetails: SubCategory | null = null;
  editForm: FormGroup = new FormGroup({
    name: new FormControl(),
    cbiClass: new FormControl(),
    status: new FormControl(),
  });
  statusOptions: GenericOption[] = [
    {label: 'Active', value: 1},
    {label: 'Archive', value: 0},
  ];

  constructor(
      private readonly workTypeService: WorkTypeService
  ) { }

  ngOnInit(): void {}

  selectTab(value: any): void {}

  cancel(): void {
    this.cancelled.emit(false);
  }

  init(): void {
    if (this.viewStatus === 'add' && this.workCategoryDetails && this.workCategoryDetails.cbi_class && this.workCategoryDetails.cbi_class.id) {
      this.editForm.get('cbiClass')?.setValue(this.workCategoryDetails.cbi_class.id);
    }
  }

  add(): void {
    this.gather();
    if(this.parcel && this.workCategoryDetails && this.workCategoryDetails.type_id && this.workCategoryDetails.id) {
      this.isLoading = true;
      this.workTypeService.addSubCategory(this.workCategoryDetails.type_id, this.workCategoryDetails.id, this.parcel).subscribe(data => {
        this.isLoading = false;
        this.showDone = true;
      }, error => {
        this.isLoading = false;
        this.completed.emit(true);
      })
    }
  }

  update(): void {
    this.gather();
    if(
        this.parcel
        && this.workSubCategoryDetails
        && this.workSubCategoryDetails.type_id
        && this.workSubCategoryDetails.category_id
        && this.workSubCategoryDetails.id) {
      this.isLoading = true;
      this.workTypeService.updateSubCategory(
          this.workSubCategoryDetails.type_id,
          this.workSubCategoryDetails.category_id,
          this.workSubCategoryDetails.id,
          this.parcel
      ).subscribe(data => {
        this.isLoading = false;
        this.showDone = true;
      }, error => {
        this.isLoading = false;
      })
    }
  }

  gather(): void {
    if(this.editForm) {
      this.parcel = {
        name: this.editForm.get('name')?.value,
        status: this.viewStatus === 'add' ? 1 : this.editForm.get('status')?.value,
        cbi_class_id: this.editForm.get('cbiClass')?.value
      };
    }
  }

  close(): void {
    this.completed.emit(true);
    this.showDone = false;
  }

} // end of class
